
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, AlertCircle } from "lucide-react";
import { ReportCard } from "./ReportCard";

interface UsdaReport {
  id: string;
  report_id: string;
  slug_id: string | null;
  slug_name: string | null;
  report_name: string | null;
  published_date: string | null;
  market_types: any;
  commodities: string[] | null;
  varieties: string[] | null;
  market_cities: string[] | null;
  report_type: string | null;
  created_at: string;
  updated_at: string;
}

interface RecentReportsSectionProps {
  allReports: UsdaReport[];
}

export const RecentReportsSection = ({ allReports }: RecentReportsSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-green-800 flex items-center space-x-2">
          <TrendingUp size={20} />
          <span>Recent USDA Reports</span>
          <Badge variant="secondary">{allReports.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {allReports.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex items-start space-x-2">
                <AlertCircle size={16} className="text-yellow-600 mt-0.5" />
                <div className="text-sm text-yellow-800">
                  <p className="font-medium mb-1">No Reports Available</p>
                  <p className="mb-2">
                    No USDA reports are currently available. This may be due to API authentication requirements.
                  </p>
                  <p>
                    Use the USDA Data Processor above to fetch reports when API access is configured.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            {allReports.slice(0, 10).map((report) => (
              <ReportCard 
                key={report.id} 
                report={report} 
                isProfileReport={false}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
